var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinanceBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11V15H7V11H9ZM5 9H7H9H11V11V15V17H9H7H5V15V11V9ZM17 11V15H15V11H17ZM13 9H15H17H19V11V15V17H17H15H13V15V11V9Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17H6C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17ZM6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15H6Z",
    fill: "#6B92FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92866 9.00002H18.0713C18.5842 9.00002 19 8.58425 19 8.07136C19 7.67774 18.7518 7.32688 18.3807 7.19575L12.3331 5.05907C12.1176 4.98291 11.8824 4.98291 11.6669 5.05907L5.61929 7.19575C5.24815 7.32688 5 7.67774 5 8.07136C5 8.58425 5.41577 9.00002 5.92866 9.00002ZM4.95303 5.30999C3.78259 5.72352 3 6.83002 3 8.07136C3 9.68882 4.3112 11 5.92866 11H18.0713C19.6888 11 21 9.68882 21 8.07136C21 6.83002 20.2174 5.72352 19.047 5.30999L12.9994 3.17331C12.3527 2.94483 11.6473 2.94483 11.0006 3.17331L4.95303 5.30999Z",
    fill: "#6B92FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceBuilding);
export default __webpack_public_path__ + "static/media/finance-building.9863ed2e.svg";
export { ForwardRef as ReactComponent };